// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__s2o6e","text":"styles_text__W6BXZ","editIcon":"styles_editIcon__xVf2g"};